import { createSelector } from 'reselect';

import { Locale } from '../providers/LanguageProvider';

import selectState from './selectState';

const selectLocale = createSelector(
  selectState,
  (state) => (state.intl.locale as Locale) || Locale.EnglishUS,
);

export default selectLocale;
